@let username = player().user.username;

<div class="player-info">
  <img class="avatar" [src]="player().user.avatarUrl" [alt]="`${username} avatar's`" />
  @if(uiSize() !== 'small'){
  <p class="username">{{ username }}</p>
  }
  <div class="speed">
    @if(uiSize() !== 'small'){
    <app-icon icon="speed" [size]="1.25" [color]="isClient() ? '#ffc947' : 'white' " />
    }
    <p [appCounterEffect]="player().data.speed" [transform]="speedPipeTransform"></p>
  </div>
</div>

@if(!isClient()){
<p class="relative-distance" [class.negative]="player().data.distance <= 0" [appCounterEffect]="player().data.distance"
  [transform]="distancePipeTransform"></p>
}

<span class="position">{{ index() + 1 }}</span>
@if (flagUrl(); as flagUrl) {
<div class="flag">
  <img [src]="flagUrl" />
</div>
}